import styled from 'styled-components/macro';

export const ListContainer = styled.div`
  width: 100%;
  min-width: 0;
`;

export * from '../../student/elements/Task.js';
export * from './StudentModuleLearning';
